import * as React from 'react';

import type { TimeSheetEntryWorkType } from '@acceligentllc/shared/enums/timeSheetEntryWorkType';
import { TimeSheetEntryWorkTypeLabel } from '@acceligentllc/shared/enums/timeSheetEntryWorkType';

import { SegmentLabel } from '@acceligentllc/storybook';

import LockedValue from 'af-components/LockedValue';

import { previewSectionClass, previewSectionClassColumn2, previewSectionClassRow } from '../../helpers';

type OwnProps = {
	payrollDifferential: boolean;
	payrollDifferentialAmount: Nullable<number>;
	payrollDifferentialWorkTypes: Nullable<TimeSheetEntryWorkType[]>;
};

type Props = OwnProps;

const PrevailingWageDeductionSection: React.FC<Props> = (props) => {
	const {
		payrollDifferential,
		payrollDifferentialAmount,
		payrollDifferentialWorkTypes,
	} = props;

	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Prevailing Wage Differential"
				tooltip="Settings and rate details related to Payroll Differential (PWD) tracking, labor activity selections, and MHA calculations for this job."
			/>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn2}>
					<LockedValue label="Prevailing Wage Deduction" value={payrollDifferential ? 'YES' : 'NO'} />
				</div>
				{
					payrollDifferential && (
						<>
							<div className={previewSectionClassColumn2}>
								<LockedValue label="Differential Amount ($/hr)" value={`$${(+(payrollDifferentialAmount ?? 0)).toFixed(2)}`} />
							</div>
							<div className={previewSectionClassColumn2}>
								<LockedValue label="Job Work Types" value={payrollDifferentialWorkTypes!.map((type) => TimeSheetEntryWorkTypeLabel[type]).join(', ')} />
							</div>
						</>
					)
				}
			</div>
		</div>
	);
};

export default React.memo(PrevailingWageDeductionSection);
